"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MixPlaceholder_exports = {};
__export(MixPlaceholder_exports, {
  default: () => MixPlaceholder_default
});
module.exports = __toCommonJS(MixPlaceholder_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.6289 11.5L17.7266 11.5195C17.7526 11.5195 17.7786 11.526 17.8047 11.5391C17.8307 11.5521 17.8568 11.5716 17.8828 11.5977C17.9219 11.6237 17.9479 11.6562 17.9609 11.6953C17.987 11.7344 18 11.7734 18 11.8125V13.043L17.9805 13.1406C17.9805 13.1667 17.9674 13.1927 17.9414 13.2188C17.9284 13.2448 17.9154 13.2708 17.9023 13.2969C17.8633 13.3229 17.8177 13.349 17.7656 13.375C17.7266 13.388 17.681 13.3945 17.6289 13.3945C17.5898 13.3945 17.5443 13.388 17.4922 13.375C17.4531 13.362 17.4206 13.3424 17.3945 13.3164C17.3555 13.2773 17.3229 13.2448 17.2969 13.2188C17.2839 13.1797 17.2773 13.1341 17.2773 13.082V12.2031H13.9766L15.7344 14.3516L15.7539 14.4102C15.7669 14.4362 15.7734 14.4622 15.7734 14.4883C15.7865 14.5013 15.793 14.5208 15.793 14.5469C15.793 14.5859 15.7865 14.6185 15.7734 14.6445C15.7734 14.6706 15.7669 14.7031 15.7539 14.7422L15.7344 14.7812L13.957 17.0469H17.2773V16.207V16.1094C17.2904 16.0833 17.3034 16.0573 17.3164 16.0312C17.3294 16.0052 17.349 15.9857 17.375 15.9727C17.401 15.9336 17.4336 15.9076 17.4727 15.8945C17.5117 15.8685 17.5508 15.8555 17.5898 15.8555H17.6289L17.7266 15.875C17.7526 15.875 17.7786 15.8815 17.8047 15.8945C17.8307 15.9076 17.8568 15.9271 17.8828 15.9531C17.9219 15.9792 17.9479 16.0117 17.9609 16.0508C17.987 16.0768 18 16.1159 18 16.168V17.418L17.9805 17.4961C17.9805 17.5221 17.974 17.5482 17.9609 17.5742C17.9479 17.5872 17.9284 17.6068 17.9023 17.6328C17.8763 17.6719 17.8438 17.7044 17.8047 17.7305C17.7656 17.7435 17.7266 17.75 17.6875 17.75H13.5273H13.4297L13.3516 17.7305C13.3255 17.7174 13.2995 17.7044 13.2734 17.6914C13.2604 17.6784 13.2409 17.6654 13.2148 17.6523C13.1628 17.6133 13.1172 17.5742 13.0781 17.5352C13.0521 17.4831 13.0326 17.4245 13.0195 17.3594C13.0065 17.2943 13 17.2357 13 17.1836C13.013 17.1315 13.0391 17.0794 13.0781 17.0273L13.0977 16.9883L14.9727 14.5859L13.1172 12.2812L13.0781 12.2227L13.0391 12.1641C13.0391 12.151 13.0326 12.1315 13.0195 12.1055C13.0195 12.0794 13.0195 12.0599 13.0195 12.0469L13 11.9883L13.0195 11.8906C13.0195 11.8516 13.0326 11.8125 13.0586 11.7734C13.0846 11.7344 13.1107 11.6953 13.1367 11.6562C13.1888 11.6172 13.2409 11.5846 13.293 11.5586C13.3451 11.5326 13.4036 11.513 13.4688 11.5H17.6289ZM11.418 3.19922C11.5352 3.19922 11.6393 3.23177 11.7305 3.29688C11.8216 3.34896 11.8932 3.42057 11.9453 3.51172L12.0039 3.60938L14.6406 10.25H13.4688H13.332C13.2279 10.263 13.1237 10.2891 13.0195 10.3281C12.9284 10.3542 12.8372 10.3867 12.7461 10.4258V10.3281L12.707 10.2305L11.3203 6.63672C11.2943 6.55859 11.2487 6.48698 11.1836 6.42188C11.1185 6.35677 11.0469 6.3112 10.9688 6.28516C10.8255 6.23307 10.6823 6.23307 10.5391 6.28516C10.3958 6.32422 10.2852 6.40885 10.207 6.53906L10.1484 6.63672L8.80078 10.2305C8.77474 10.2695 8.75521 10.3086 8.74219 10.3477C8.74219 10.3867 8.74219 10.4258 8.74219 10.4648C8.74219 10.6081 8.78776 10.7383 8.87891 10.8555C8.98307 10.9727 9.11328 11.0443 9.26953 11.0703L9.36719 11.0898L11.457 11.0703L11.8086 11.5391L11.7891 11.6562L11.7695 11.8711L11.75 12.0859L11.7891 12.2617L11.8086 12.3789C11.8216 12.444 11.8346 12.5026 11.8477 12.5547C11.8737 12.6068 11.8997 12.6589 11.9258 12.7109L11.9648 12.7891H8.23438C8.13021 12.7891 8.02604 12.8151 7.92188 12.8672C7.83073 12.9193 7.75911 12.9974 7.70703 13.1016L7.66797 13.1992L6.55469 16.0898C6.51562 16.194 6.45052 16.2852 6.35938 16.3633C6.28125 16.4284 6.1901 16.474 6.08594 16.5H5.96875H5.36328C5.32422 16.5 5.28516 16.5 5.24609 16.5C5.20703 16.487 5.16797 16.474 5.12891 16.4609C4.98568 16.3958 4.875 16.2982 4.79688 16.168C4.73177 16.0378 4.71224 15.901 4.73828 15.7578L4.77734 15.6406L9.5625 3.60938C9.60156 3.50521 9.66016 3.42057 9.73828 3.35547C9.82943 3.27734 9.93359 3.23177 10.0508 3.21875L10.1484 3.19922H11.418Z",
      fill: "currentColor"
    }
  )
);
const SvgMixPlaceholder = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MixPlaceholder_default = SvgMixPlaceholder;
